import React, { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../globalhelper/helper";
import globalhelper from "../../helper/globalhelper";
import FormBasicInput from "../CI/FormBasicInput";
import Api from '../../config.json'
import "../CI/LARPopup.css";
import FetchEmail from "./FetchEmail";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DownloadIcon from "@mui/icons-material/Download";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showAlert, showLoader } from "../../redux/Common/commonActions";
import { CSVLink } from "react-csv";
import axios from "axios";

const InboxInitialInput = () => {
  let dispatch = useDispatch();
  const gstValidationResult = useSelector((state) => state.VR2?.gstValidationResult);
  const [mainScreen, showMainScreen] = useState(false);
  const [searchScreen, showSearchScreen] = useState(true);
  const [resultArray, setResultArray] = useState([]);
  const [message, setMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    company: "",
    fromDate: "",
    toDate: "",
  });
  const [companyName, setCompanyName] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [orgid, setOrgid] = useState("");
  const [isSessionEstablished, setIsSessionEstablished] = useState(false)
  const [sessionValidity, setSessionValidity] = useState(null)
  const [timeLeft, setTimeLeft] = useState("");
  const [gstDialogOpen, setGstDialogOpen] = useState(false);
  const [gstin, setGstin] = useState("");
  const [otp, setOtp] = useState("");
  const [gstOtpMessage, setGstOtpMessage] = useState("");
  const [isOtpStep, setIsOtpStep] = useState(false);
  const [isGeneratingOTP, setIsGeneratingOTP] = useState(false);
  const [isOtpSubmitting, setIsOtpSubmitting] = useState(false);
  const [isValidationSubmitting, setIsValidationSubmitting] = useState(false);
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationPeriod, setValidationPeriod] = useState(moment());
  const [validationInvoices, setValidationInvoices] = useState([]);
  const [showValidationResults, setShowValidationResults] = useState(false);
  const [isCheckingSessionStatus, setIsCheckingSessionStatus] = useState(false);

  useEffect(() => {
    let intervalId;
    if (isSessionEstablished && sessionValidity) {
      intervalId = setInterval(() => {
        const now = moment();
        const validUntil = moment(sessionValidity);
        const diff = validUntil.diff(now);
        if (diff > 0) {
          const duration = moment.duration(diff);
          const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
          const minutes = String(duration.minutes()).padStart(2, '0');
          const seconds = String(duration.seconds()).padStart(2, '0');
          setTimeLeft(`${hours}:${minutes}:${seconds}`);
        } else {
          setTimeLeft("00:00:00");
          setIsSessionEstablished(false);
          clearInterval(intervalId);
        }
      }, 1000);
    } else {
      setTimeLeft("");
    }
    return () => clearInterval(intervalId);
  }, [isSessionEstablished, sessionValidity]);


  useEffect(() => {
    const checkSession = async () => {
      const id = companyDetails.filter(
        (item) => item.orgname === formData.company,
      );
      if (!id || id.length === 0) {
        return;
      }
      try {
        setIsCheckingSessionStatus(true);
        let { res } = await postRequest(`api/auth/checkSessionStatus`, {
          orgid: id[0].orgid
        })
        if (res.status === "success") {
          setGstin(res?.data?.gstin || "");
          setSessionValidity(res?.data?.validity || null)
          setIsSessionEstablished(true);
        } else {
          setGstin("");
          setIsSessionEstablished(false);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsCheckingSessionStatus(false);
      }
    };

    if (Api.gstZen?.[localStorage.getItem('tenant_id')]) {
      checkSession();
    }

    const intervalId = setInterval(() => {
      if (Api.gstZen?.[localStorage.getItem('tenant_id')]) {
        checkSession();
      }
    }, 3600000); // 1 hour

    return () => clearInterval(intervalId);
  }, [formData.company])
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then((response) => {
        console.log(response.res.data);
        const responseData = response.res.data;
        const orgname = responseData.map((item) => item.orgname);
        setCompanyDetails(responseData);
        setCompanyName(orgname);
        if (orgname.length === 1) {
          setFormData((prev) => {
            return { ...prev, company: orgname[0] };
          });
        }
      })
      .catch((err) => console.log(err));
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData((prev) => {
      return { ...prev, fromDate: firstDay, toDate: lastDay };
    });
  }, []);

  const handleChange = (name, value) => {
    setFormData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleEstablishGSTSession = () => {
    if (!formData.company) {
      dispatch(showAlert("Please select a company first", "error"));
      return;
    }
    const id = companyDetails.filter(
      (item) => item.orgname === formData.company,
    );
    if (!id || id.length === 0) {
      dispatch(showAlert("Company details not found", "error"));
      return;
    }
    setGstin(id[0].gstin || "");
    setOtp("");
    setGstOtpMessage("");
    setIsOtpStep(false);
    setGstDialogOpen(true);
  };

  const handleGenerateOTP = async () => {
    try {
      setIsGeneratingOTP(true);
      dispatch(showLoader());
      let isAuthendicated = await globalhelper.gstZenLogin(localStorage.getItem('tenant_id'));
      if (!isAuthendicated) {
        dispatch(showAlert("GSTZen Authentication Failed", "error"));
        return false;
      }
      let { res } = await postRequest(`api/auth/generateOTPforGST`, { gstin, bearerToken: globalhelper.getGSTBearerToken(), username: Api.gstZen[localStorage.getItem('tenant_id') || '']?.gst_username });
      console.log(res, "res")
      if (res.status === "success") {
        setGstOtpMessage(res.data?.message);
        setIsOtpStep(true);
      } else {
        setGstOtpMessage(res.message);
        setIsOtpStep(false);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsGeneratingOTP(false);
      dispatch(hideLoader());
    }
  };

  const handleSubmitOTP = async () => {
    try {
      setIsOtpSubmitting(true);
      dispatch(showLoader());
      const id = companyDetails.filter(
        (item) => item.orgname === formData.company,
      );
      let establishedReponse = await globalhelper.establishSessionByOTP(otp, gstin, localStorage.getItem('tenant_id'))
      setIsSessionEstablished(establishedReponse)
      if (establishedReponse?.status === 0) {
        dispatch(showAlert("Failed to establish GST session", "error"));
        return false;
      }
      let response = await postRequest(`api/auth/establishGSTsession`, {
        orgid: id[0].orgid,
        token: globalhelper.getGSTBearerToken(),
        otp: otp,
        gstin: gstin
      });
      console.log(response);
      setGstDialogOpen(false);
      dispatch(showAlert("GST Session Established Successfully", "success"));
    } catch (err) {
      console.log(err);
      dispatch(showAlert("Failed to establish GST session", "error"));
    } finally {
      setIsOtpSubmitting(false);
      dispatch(hideLoader());
    }
  };

  const handleReset = () => {
    setFormData({
      company: "",
    });
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData((prev) => {
      return { ...prev, fromDate: firstDay, toDate: lastDay };
    });
    setResultArray([]);
  };

  const getDateList = (startDate, endDate) => {
    const dateList = [];

    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const dateString = currentDate.toISOString().split("T")[0];
      dateList.push(dateString);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateList;
  };

  const getDateListOldFormat = (startDate, endDate) => {
    const dates = [];
    let currentDate = startDate;

    while (currentDate <= endDate) {
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // Months are 0-based
      const day = currentDate.getDate();

      const formattedDate = `${year}-${month}-${day}`;
      dates.push(formattedDate);

      // Increment currentDate for the next iteration
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  const formatDates = (dateArray) => {
    const formattedDates = [];

    dateArray.forEach((inputDate) => {
      const dateParts = inputDate.split("-");
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);

      const date = new Date(year, month, day);

      const fday = String(date.getDate()).padStart(2, "0");
      const fmonth = String(date.getMonth() + 1).padStart(2, "0");
      const fyear = date.getFullYear();

      const formatDate = `${fday}-${fmonth}-${fyear}`;

      formattedDates.push(formatDate);
    });

    return formattedDates;
  };

  const formatDatesOldFormat = (dateArray) => {
    const formattedDates = [];

    dateArray.forEach((inputDate) => {
      const dateParts = inputDate.split("-");
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);

      const date = new Date(year, month, day);

      const fday = String(date.getDate());
      const fmonth = String(date.getMonth() + 1);
      const fyear = date.getFullYear();

      const formatDate = `${fday}-${fmonth}-${fyear}`;

      formattedDates.push(formatDate);
    });

    return formattedDates;
  };

  const handleGSTValidation = async () => {
    try {
      setValidationInvoices([]);
      setShowValidationResults(false);
      setValidationDialogOpen(true);
    } catch (err) {
      console.log(err);
    }
  }

  const submitGSTValidation = async (period) => {
    try {
      console.log(period);

      setIsValidationSubmitting(true);
      dispatch(showLoader());
      const periodFormat = period.format("MMYYYY"); // standard format
      if (!isSessionEstablished) {
        dispatch(showAlert("GST Session Not Established", "error"));
        return false;
      }
      await handleChange('fromDate', moment(period).startOf('month').format("YYYY-MM-DD"))
      await handleChange('toDate', moment(period).endOf('month').format("YYYY-MM-DD"))
      let invoiveData = await getIvoiceByIvoiceDate(moment(period).startOf('month').format("YYYY-MM-DD"), moment(period).endOf('month').format("YYYY-MM-DD"));
      if (!invoiveData || invoiveData?.length === 0) {
        dispatch(showAlert("No Invoices Found", "error"));
        return false;
      }
      let GST2Aresponse = await fetch('api/gstr2/b2b/', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Authorization": globalhelper.getGSTBearerToken()
        }, body: JSON.stringify({
          "ret_period": periodFormat,
          "gstin": gstin,
        })
      })
      let GST2Bresponse = await fetch('/api/gstr2/2b/', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Authorization": globalhelper.getGSTBearerToken()
        }, body: JSON.stringify({
          "ret_period": periodFormat,
          "gstin": gstin,
        })
      })
      let GST2AData = await GST2Aresponse.json();
      let GST2BData = await GST2Bresponse.json();
      console.log("B2B Data:", GST2AData);
      console.log("B2B Data:", GST2BData);
      if (!GST2AData?.message?.b2b) {
        dispatch(showAlert(typeof GST2AData?.message === "string" ? GST2AData?.message : "No Invoices Found", "error"));
        return false;
      }
      setValidationDialogOpen(false);
      let response = await postRequest("api/vr2/ValidateInvoiceForGST2", {
        period: periodFormat,
        gstin: gstin,
        GST2Ab2b: GST2AData?.message?.b2b || [],
        GST2Bb2b: GST2BData?.message?.data?.docdata?.b2b,
        "RecivedInvoices": invoiveData
      });

      console.log("Validation Response:", response);
      if (response && response.res && response.res.data) {
        const sortedData = response.res.data?.sort((a, b) =>
          Number(b?.["GSTR-2 Availablity"]) - Number(a?.["GSTR-2 Availablity"]) ||
          Number(b?.["Inbox Availablity"]) - Number(a?.["Inbox Availablity"])
        );
        setValidationInvoices(sortedData);
        dispatch({ type: 'set_gst_validation_result', payload: sortedData });
      } else {
        setValidationInvoices([]);
        dispatch({ type: 'set_gst_validation_result', payload: null });
      }
      setShowValidationResults(true);
    } catch (err) {
      console.log(err);
      dispatch(showAlert("Validation Failed", "error"));
    } finally {
      setIsValidationSubmitting(false);
      dispatch(hideLoader());
    }
  }

  const getIvoiceByIvoiceDate = async (fromDate, toDate) => {

    showMainScreen(false);
    const dateList = getDateList(
      new Date(fromDate),
      new Date(toDate),
    );

    const dateListOld = getDateListOldFormat(
      new Date(fromDate),
      new Date(toDate),
    );

    console.log(dateListOld);

    const formatDate = formatDates(dateList);

    const formatDateOld = formatDatesOldFormat(dateListOld);

    const finalFormat = formatDate.concat(formatDateOld);

    const id = companyDetails.filter(
      (item) => item.orgname === formData.company,
    );

    const companyid = id.map((item) => item.orgid);

    if (finalFormat && formData.company) {
      let response = await postRequest(`api/dashboard/inboxFilter`, {
        item: finalFormat,
        companies: companyid[0],
        isFromValidation: true,
      })
      try {
        console.log(response.res.data);
        if (response.res.data.length) {
          setOrgid(companyid[0]);
          let sortedData = response.res.data.sort((a, b) => {
            return new Date(b.Date) - new Date(a.Date);
          });
          setResultArray(sortedData);
          showMainScreen(true);
          return sortedData
        } else {
          console.log("No Records to display");

          setMessage(true);
          setErrorMessage("No Records to display");
          dispatch(hideLoader());
        }
        return null
      }
      catch (err) {
        console.log(err);
        return null
      }
    } else {
      console.log(finalFormat || formData.company);

      setMessage(true);
      setErrorMessage("Please select all the required fields");
    }
    return null
  }

  const handleSubmit = (RunBackGround = false) => {
    if (!RunBackGround) {
      dispatch(showLoader());
    }

    showMainScreen(false);
    const dateList = getDateList(
      new Date(formData.fromDate),
      new Date(formData.toDate),
    );

    const dateListOld = getDateListOldFormat(
      new Date(formData.fromDate),
      new Date(formData.toDate),
    );

    console.log(dateListOld);

    const formatDate = formatDates(dateList);

    const formatDateOld = formatDatesOldFormat(dateListOld);

    const finalFormat = formatDate.concat(formatDateOld);

    const id = companyDetails.filter(
      (item) => item.orgname === formData.company,
    );

    const companyid = id.map((item) => item.orgid);

    if (finalFormat && formData.company) {
      postRequest(`api/dashboard/inboxFilter`, {
        item: finalFormat,
        companies: companyid[0],
        isFromValidation: false,
      })
        .then((response) => {
          console.log(response.res.data);
          if (response.res.data.length) {
            setOrgid(companyid[0]);
            let sortedData = response.res.data.sort((a, b) => {
              return new Date(b.Date) - new Date(a.Date);
            });
            setResultArray(sortedData);
            showMainScreen(true);
          } else {
            console.log("No Records to display");

            setMessage(true);
            setErrorMessage("No Records to display");
            dispatch(hideLoader());
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log(finalFormat || formData.company);

      setMessage(true);
      setErrorMessage("Please select all the required fields");
    }
  };

  return (
    <>
      {searchScreen && (
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              Please select the date range to view Reports
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4} md={3}>
                <Autocomplete
                  options={companyName || []}
                  value={formData.company}
                  onChange={(e, newValue) => handleChange("company", newValue)}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Company Name"
                      variant="outlined"
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="ForPrdFrom"
                    value={formData.fromDate}
                    views={["day", "month", "year"]}
                    onChange={(newValue) => {
                      handleChange("fromDate", newValue.format("YYYY-MM-DD"));
                    }}
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="ForPrdTo"
                    value={formData.toDate}
                    views={["day", "month", "year"]}
                    onChange={(newValue) => {
                      handleChange("toDate", newValue.format("YYYY-MM-DD"));
                    }}
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} md={5} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                >
                  Reset
                </Button>
                {Api.gstZen?.[localStorage.getItem('tenant_id')] && (
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={isSessionEstablished || isCheckingSessionStatus}
                    onClick={handleEstablishGSTSession}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Establish GST session {timeLeft ? `(${timeLeft})` : ""}
                  </Button>
                )}
                {Api.gstZen?.[localStorage.getItem('tenant_id')] && isSessionEstablished && (
                  <Button
                    variant="contained"
                    color="success"
                    style={{ whiteSpace: "nowrap" }}
                    onClick={() => {
                      if (gstValidationResult && gstValidationResult.length > 0) {
                        setValidationInvoices(gstValidationResult);
                        setShowValidationResults(true);
                        setValidationDialogOpen(true);
                      } else {
                        handleGSTValidation();
                      }
                    }}
                  >
                    {gstValidationResult && gstValidationResult.length > 0 ? "Validation Results" : "GSTR-2 validation"}
                  </Button>
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}

      {resultArray.length === 0 && message && (
        <Box style={{ margin: "auto" }}>
          <Alert severity="warning">
            <AlertTitle>No Data Found</AlertTitle>
            There is no data to display at the moment.
          </Alert>
        </Box>
      )}
      {mainScreen && (
        <FetchEmail
          handleSubmit={handleSubmit}
          resultArray={resultArray}
          showMainScreen={showMainScreen}
          orgid={orgid}
          companyName={formData.company}
          showSearchScreen={showSearchScreen}
        />
      )}

      <Dialog open={gstDialogOpen} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') { setGstDialogOpen(false); } }} maxWidth="sm" fullWidth>
        <DialogTitle>Establish GST Session</DialogTitle>
        <DialogContent>
          {gstOtpMessage && (
            <Alert severity="info" style={{ marginBottom: "15px", marginTop: "10px" }}>
              {gstOtpMessage}
            </Alert>
          )}
          {!isOtpStep ? (
            <TextField
              autoFocus
              margin="dense"
              label="Enter GSTIN"
              type="text"
              fullWidth
              variant="outlined"
              value={gstin}
              onChange={(e) => setGstin(e.target.value)}
              style={{ marginTop: "10px" }}
            />
          ) : (
            <TextField
              autoFocus
              margin="dense"
              label="Enter OTP"
              type="text"
              fullWidth
              variant="outlined"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              style={{ marginTop: "10px" }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setGstDialogOpen(false)} color="inherit">
            Cancel
          </Button>
          {!isOtpStep ? (
            <Button onClick={handleGenerateOTP} color="primary" variant="contained" disabled={isGeneratingOTP}>
              Generate OTP
            </Button>
          ) : (
            <Button onClick={handleSubmitOTP} color="primary" variant="contained" disabled={isOtpSubmitting}>
              Submit
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* GSTR-2 Validation Dialog */}
      <Dialog open={validationDialogOpen} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') { setValidationDialogOpen(false); if (showValidationResults) dispatch({ type: 'set_gst_validation_result', payload: null }); } }} maxWidth={showValidationResults ? "lg" : "sm"} fullWidth>
        <DialogTitle>GSTR-2 Validation</DialogTitle>
        <DialogContent>
          {!showValidationResults ? (
            <Box mt={2}>
              <Alert severity="info" style={{ marginBottom: "15px" }}>
                This process may take a long time, so kindly don't close this tab.
              </Alert>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  views={["month", "year"]}
                  label="Month and Year"
                  value={validationPeriod}
                  onChange={(newValue) => setValidationPeriod(newValue)}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </LocalizationProvider>
            </Box>
          ) : (
            <Box mt={2}>
              {validationInvoices && validationInvoices.length > 0 ? (
                <TableContainer component={Paper} style={{ maxHeight: '60vh' }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        {Object.keys(validationInvoices[0]).map((key, idx) => (
                          <TableCell key={idx}><b>{key}</b></TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {validationInvoices.map((row, idx) => (
                        <TableRow key={idx}>
                          {Object.entries(row).map(([key, val], i) => (
                            <TableCell key={i}>
                              {(key === "GSTR-2A Availablity" || key === "GSTR-2B Availablity" || key === "Inbox Availablity") && typeof val === 'boolean' ? (
                                val ? <CheckCircleIcon style={{ color: "green" }} /> : <CancelIcon style={{ color: "red" }} />
                              ) : (
                                typeof val === 'object' ? JSON.stringify(val) : String(val)
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Alert severity="info">No invoices found for this period.</Alert>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {showValidationResults ? (
            <>
              <CSVLink data={validationInvoices} filename={"validation_results.csv"} style={{ textDecoration: 'none' }}>
                <Button color="secondary" variant="contained" startIcon={<DownloadIcon />}>
                  Download CSV
                </Button>
              </CSVLink>
              <Button onClick={() => { let fromDate = moment(validationPeriod).startOf('month').format("YYYY-MM-DD"); let toDate = moment(validationPeriod).endOf('month').format("YYYY-MM-DD"); getIvoiceByIvoiceDate(fromDate, toDate); setValidationDialogOpen(false); dispatch({ type: 'set_gst_validation_result', payload: null }); }} color="primary" style={{ marginLeft: '10px' }}>
                Close
              </Button>
            </>
          ) : (
            <>
              <Button onClick={() => setValidationDialogOpen(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => submitGSTValidation(validationPeriod)} color="primary" variant="contained" disabled={isValidationSubmitting}>
                Submit
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InboxInitialInput;
